import { createUseStyles } from "react-jss";

export const AppointmentHistoricFilterStyle = createUseStyles((theme: any) => ({
    container: {
        display: "flex",
        gap: theme.gaps.filter.container,
    },
    filter: {
        display: "flex",
         alignItems:"center",
        gap: theme.gaps.filter.default,
       
    },
    row: {
        display: "flex",
        gap: theme.gaps.filter.default,
    },
    item:{
        width:230
    }, 
    verticalWhiteSeparator: {
        marginTop:-15,
        height:"135%",
        borderLeft: theme.borders.default.whiteBorder,
    },
}));
